import { FC, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';

import { deleteService, getService } from '../../actions/services.action';
import { clearService } from '../../slices/services.slice';
import { useAppDispatch } from '../../store/store';
import { IService } from '../../store/types';

import { ServiceItemComponent } from './service-item.component';

export const ServicesListComponent: FC<IProps> = ({ list }) => {
  const navigation = useNavigate();

  const dispatch = useAppDispatch();

  const [visibleModal, setVisibleModal] = useState<{ isVisible: boolean; id: number }>({
    id: 0,
    isVisible: false,
  });
  const handleRedirect = async (id: number) => {
    dispatch(clearService());
    await dispatch(getService({ id }));

    navigation('/services/create-redact-service', { state: { id } });
  };

  const openWarningModal = (id: number) => {
    setVisibleModal({ id, isVisible: true });
  };

  const handleDelete = async () => {
    await dispatch(deleteService({ id: visibleModal.id }));
    setVisibleModal({ id: 0, isVisible: false });
  };

  return (
    <>
      <div className={'grid grid-cols-4 gap-4'}>
        {list.length
          ? list.map((item, key) => (
              <ServiceItemComponent
                content={item}
                onClick={handleRedirect}
                openWarningModal={openWarningModal}
                key={key}
              />
            ))
          : null}
      </div>
      <Dialog
        header="Вы действительно хотите удалить сервис?"
        visible={visibleModal.isVisible}
        style={{ width: '50vw' }}
        onHide={() => setVisibleModal({ ...visibleModal, isVisible: false })}
      >
        <Button label="Удалить" severity="success" onClick={handleDelete} className={'w-full'} />
      </Dialog>
    </>
  );
};

interface IProps {
  list: IService[];
}
